import { HttpInterceptorFn, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';
import { JWTService } from '../services/jwt-parser.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const _LocalStorageService = inject(LocalStorageService);
  const _JWTService = inject(JWTService);
  const router = inject(Router);

  const token = _LocalStorageService.getItem('lavuro-api-token');
  if (!token) return next(req);

  let expired = _JWTService.parse(token).exp * 1000 < new Date().getTime();
  if (expired) {
    router.navigate(['/site', 'login']);
    return next(req); // Opcional, si quieres permitir que continúe la solicitud a pesar de la redirección.
  }

  const headers = req.clone({
    headers: req.headers.set('Authorization', `Bearer ${token}`)
  });

  const newReq = headers.clone({
    params: (req.params ? req.params : new HttpParams())
      .set('tmp', new Date().getTime().toString())
  });

  return next(newReq);
};
